import styled from "styled-components";

export const SeparatoreSearch = styled.div`
    background: #ccc;
    width: 1px;
    height: 30px;
    margin-right: 10px;
`;


